export default {
  GridEnergy: 0,
  DieselPrimeMover: 1,
  DieselEquipment: 2,
  Gasoline: 3,
  NaturalGas: 4
}